import * as api from '../../../../../api/masters/users/rolePermission/rolePermissionApi';
import {
  FETCH_ROLE_PERMISSIONS_REQUEST,
  FETCH_ROLE_PERMISSIONS_SUCCESS,
  FETCH_ROLE_PERMISSIONS_FAILURE,
  SAVE_ROLE_PERMISSIONS_REQUEST,
  SAVE_ROLE_PERMISSIONS_SUCCESS,
  SAVE_ROLE_PERMISSIONS_FAILURE
} from '../../../../types/masters/users/rolePermission/rolePermissionTypes';

export const fetchRolePermissions = (roleId) => async (dispatch) => {
  dispatch({ type: FETCH_ROLE_PERMISSIONS_REQUEST });
  try {
    const permissions = await api.fetchRolePermissions(roleId);
    dispatch({ type: FETCH_ROLE_PERMISSIONS_SUCCESS, payload: permissions });
  } catch (error) {
    dispatch({ type: FETCH_ROLE_PERMISSIONS_FAILURE, error: error.message });
  }
};

export const saveRolePermissions = ({ roleId, permissions }) => async (dispatch) => {
  dispatch({ type: SAVE_ROLE_PERMISSIONS_REQUEST });
  try {
    await api.saveRolePermissions(roleId, permissions);
    dispatch({ type: SAVE_ROLE_PERMISSIONS_SUCCESS });
    // Optionally, refetch permissions after save
    dispatch(fetchRolePermissions(roleId));
  } catch (error) {
    dispatch({ type: SAVE_ROLE_PERMISSIONS_FAILURE, error: error.message });
  }
};